export const getIsSessionListFiltered = (
  unreadOnly: boolean,
  isOwnScopeOnly: boolean,
  searchString: string,
) => unreadOnly || isOwnScopeOnly || !!searchString?.trim();
